import React from "react";
import MyModal from "../../Common/my-modal/my-modal.component";
import ModalForm from "./modal-form";
import { IExtendTrialFormValues } from "../../../common/validations/extend-trial.validations";

interface ExtendTrialModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: (values: IExtendTrialFormValues) => void;
  loading?: boolean;
  isSendRequestView?: boolean;
}

const ExtendTrialModal: React.FC<ExtendTrialModalProps> = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  isSendRequestView = true,
}) => {
  const handleConfirm = (values: IExtendTrialFormValues) => {
    onConfirm(values);
  };

  return (
    <MyModal show={show} onHide={onClose}>
      <ModalForm onClose={onClose} onConfirm={handleConfirm} loading={loading} isSendRequestView={isSendRequestView} />
    </MyModal>
  );
};

export default ExtendTrialModal;


